import { Box } from '@mui/material';
import GroupsIcon from '@mui/icons-material/GroupsOutlined';
import { PageHeader } from '../../components/PageHeader';
import { FullyPaidStudentsTable } from '../ready-to-fly/FullyPaidStudentsTable';

/** Operations → Batches to Departures: every student who has fully paid
 * the four required departure items, with their batch/departure date — the
 * same list Ready to Fly's Fully Paid tab shows. */
export const BatchesToDeparturesPage = () => (
  <Box sx={{ p: 3 }}>
    <PageHeader
      icon={GroupsIcon}
      color="#F5A623"
      title="Batches to Departures"
      subtitle="Students who have fully paid all four required payment items, with their batch and departure date."
    />
    <FullyPaidStudentsTable variant="batches" />
  </Box>
);
